import { render, staticRenderFns } from "./ApartmentImportWizard.vue?vue&type=template&id=4610dcbc&scoped=true&lang=pug&"
import script from "./ApartmentImportWizard.vue?vue&type=script&lang=ts&"
export * from "./ApartmentImportWizard.vue?vue&type=script&lang=ts&"
import style0 from "./ApartmentImportWizard.vue?vue&type=style&index=0&id=4610dcbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4610dcbc",
  null
  
)

export default component.exports